import { Outlet, createFileRoute, useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';
import { NotFound } from '@/components/Error/NotFound';
import { ProductLogoMediumPayrollCore as LogoPayrollCore } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { OperationEventConfigProvider } from '@/features/operation-event/OperationEventConfigProvider';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { PayrollCoreHeaderActions } from './-components/PayrollCoreHeaderActions';
import { getPayrollGanttDashboard } from './_layout/dashboard/-api';
import { payrollGanttDashboardQueryKey } from './_layout/dashboard/-query';
import { getPayrollCoreOperationPackages } from './_layout/operation-packages/-api';
export const Route = createFileRoute('/_staff/payroll-core/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.payrollCore'
  });
  useDocumentTitle(t('pageTitle'));
  const {
    pathname
  } = useLocation();
  /** 業務イベント詳細は自前のヘッダー（パンくず + イベント名 + タブ）を持つため二重表示を避ける */
  const hideProductHeader = pathname === '/payroll-core/person-targets' || pathname.startsWith('/payroll-core/person-targets/') || /^\/payroll-core\/operation-events\/[^/]+/.test(pathname);
  const tabs: TabWithIndicatorProps[] = useMemo(() => [{
    to: '/payroll-core/dashboard',
    children: t('tabs.dashboard'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/payroll-core/operation-events',
    children: t('tabs.operationEvents'),
    activeOptions: {
      exact: false
    }
  }, {
    to: '/payroll-core/operation-packages',
    children: t('tabs.operationPackages'),
    activeOptions: {
      exact: false
    }
  }, {
    to: '/payroll-core/archive',
    children: t('tabs.archive'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/payroll-core/config',
    children: t('tabs.config'),
    activeOptions: {
      exact: true
    }
  }], [t]);
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <OperationEventConfigProvider value={{
    pagesRootKey: 'payrollCore',
    ganttDashboardQueryKey: payrollGanttDashboardQueryKey,
    getGanttDashboard: getPayrollGanttDashboard,
    operationPackagesQueryKey: ['payroll-core', 'operation-packages'],
    getOperationPackages: getPayrollCoreOperationPackages
  }}>
      <div className="flex h-full min-h-0 flex-1 flex-col">
        {!hideProductHeader ? <ProductHeader Logo={LogoPayrollCore} name={t('pageTitle')} tabs={tabs} type="core">
            <PayrollCoreHeaderActions />
          </ProductHeader> : null}
        <div className="flex min-h-0 flex-1 flex-col">
          <Outlet />
        </div>
      </div>
    </OperationEventConfigProvider>;
}